import axios from "../../../axios";
import config from "../../../config";
import { usePersistedStore } from "../../persisted-store";

export const createIssueEndorsementSlice = (set, get) => ({
    issueEndorsement: {
        loading: false,
        filter: {},
        data: [],
        filtered: []
    },
    getIssueEndorsmentInfo: async (params) => {
        const { param } = params;
        const token = usePersistedStore.getState().business.currentBusiness.token;
        set(state => ({ issueEndorsement: { ...state.issueEndorsement, loading: true, filter: { ...state.issueEndorsement.filter, ...params } } }));
        try {
            const resp = await axios({
                method: "post",
                baseURL: config.apiUrls(),
                url: "/v1/business/endorsement/issue-endorsement-report",
                data: {
                    BranchId: param.branchId,
                    FromDate: param.fromDate,
                    ToDate: param.toDate,
                },
                headers: { token },
            });
            set(state => ({ issueEndorsement: { ...state.issueEndorsement, loading: false, data: resp.data } }));
        } catch (error) {
            set(state => ({ issueEndorsement: { ...state.issueEndorsement, loading: false } }));
        }
    },
    filterIssueEndorsement: ({ value }) => {
        const DetailReport = get().issueEndorsement.data.DetailReport;
        const filtered = DetailReport.filter((item) => (
            (item.Insurer && item.Insurer.includes(value)) ||
            (item.ApplicantFullName && item.ApplicantFullName.includes(value)) ||
            (item.BranchTitle && item.BranchTitle.includes(value)) ||
            (item.CompanyName && item.CompanyName.includes(value))
        ));
        set(state => ({ issueEndorsement: { ...state.issueEndorsement, filtered } }));
    },
    getBusinessCommissionsMultiple: async (insuranceRequestId) => {
        const token = usePersistedStore.getState().business.currentBusiness.token;
        const filter = get().issueEndorsement.filter;
        try {
            await axios({
                method: "post",
                baseURL: config.apiUrls(),
                url: "v1/business/endorsement/Set-Business-Commissions-Multiple",
                headers: { token },
                data: insuranceRequestId,
            });
            get().getIssueEndorsmentInfo(filter);
        } catch (error) {
            // Handle error
        }
    }
});
